// removed by extract-text-webpack-plugin
module.exports = {"fadeIn":"src-components-tour-details-teasers----videoTeaser-module---fadeIn---1qN-v","fadeInUp":"src-components-tour-details-teasers----videoTeaser-module---fadeInUp---UoB5U","fadeInUpCenter":"src-components-tour-details-teasers----videoTeaser-module---fadeInUpCenter---23caI","fadeInUpSmall":"src-components-tour-details-teasers----videoTeaser-module---fadeInUpSmall----Y7bL","textCoverIn":"src-components-tour-details-teasers----videoTeaser-module---textCoverIn---2fLvi","textCoverOut":"src-components-tour-details-teasers----videoTeaser-module---textCoverOut---2Y7mJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/tour/details/teasers/videoTeaser.module.scss
// module id = 855
// module chunks = 151087471038741